import * as React from 'react'
import { FC, useCallback, useEffect } from 'react'
import { Field, Form, useFormikContext } from 'formik'

import { MuiTextFieldFormik } from '@user/components/Formik'

import { TenantLoginInput } from './typings'
import { getStyles } from './useStyles'
import {
  getCookie,
  isValidEmail,
  updateLoadingState,
} from '@sales-center/common'
import { toast } from '@sales-center/components'
import { forgotPassword } from '@user/store/authorization/api'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import Link from '@mui/material/Link'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'

import { useTheme } from '@mui/material/styles'

export const LoginFormFields: FC = () => {
  const { isValid, isSubmitting, dirty, values, setFieldValue } =
    useFormikContext<TenantLoginInput>()

  const rememberMeEmail = getCookie('loginEmail')

  const { email } = values
  const dispatch = useAppDispatch()
  const disableSave = !dirty || !isValid || isSubmitting

  const forgotPasswordHandler = useCallback(
    async (event: any) => {
      if (!isValidEmail(email)) {
        toast.error(`Need to enter valid mail`)
      } else {
        event.preventDefault()
        dispatch(updateLoadingState('visible'))
        const response = await dispatch(forgotPassword(email))
        if (forgotPassword.fulfilled.match(response)) {
          toast.success('Mail sent')
        } else {
          toast.error(
            response.payload === 'Please reset your password in PestPac'
              ? 'Please reset your password in PestPac'
              : 'Unable to sent mail',
          )
        }
        dispatch(updateLoadingState('hidden'))
      }
    },
    [dispatch, email],
  )

  const styles = getStyles(useTheme())

  useEffect(() => {
    if (rememberMeEmail) {
      setFieldValue('email', rememberMeEmail)
    }
  }, [rememberMeEmail, setFieldValue])

  return (
    <Box sx={styles.formContainer}>
      <Form noValidate>
        <Field
          name="email"
          label="Email"
          component={MuiTextFieldFormik}
          required
          fullWidth
          color="primary"
        />

        <Field
          name="password"
          label="Password"
          component={MuiTextFieldFormik}
          type="password"
          required
          fullWidth
          color="primary"
        ></Field>
        <Link
          sx={styles.forgotPass}
          component="button"
          variant="body2"
          onClick={forgotPasswordHandler}
          underline="always"
          type="button"
        >
          Forgot Password?
        </Link>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={disableSave}
          size="large"
        >
          Log In
        </Button>
      </Form>
    </Box>
  )
}
LoginFormFields.displayName = 'LoginFormFields'
